module.exports = __webpack_public_path__ + "img/onlineConsult.6cde1ff7.png";